module.exports = __webpack_public_path__ + "static/media/ot-1.bb776aa2.jpg";